<p-dialog [(visible)]="showstatusnotes" [style]="{width: '450px'}" header="Update Status & Notes">
    <div class="flex flex-column gap-3">
      <!-- Status Dropdown -->
      <div class="flex flex-column gap-2">
        <label for="status">Status</label>
        <p-dropdown id="status" [options]="statusOptions" [(ngModel)]="selectedStatus" appendTo="body"
          placeholder="Select Status" [style]="{'width':'100%'}"></p-dropdown>
      </div>

      <!-- Timepicker for Notes -->
      <div class="flex flex-column gap-2">
        <span *ngIf="selectedStatus === 'Loaded' || selectedStatus === 'Delivered'"
          class="text-sm">
          Time
        </span>

        <!-- Timepicker for Loaded -->
        <p-calendar *ngIf="selectedStatus === 'Loaded'" appendTo="body" [(ngModel)]="timeLoaded" [timeOnly]="true"
          [showTime]="true" hourFormat="12" [style]="{'width':'100%'}"></p-calendar>

        <!-- Timepicker for Delivered -->
        <p-calendar *ngIf="selectedStatus === 'Delivered'" appendTo="body" [(ngModel)]="timeDelivered"
          [timeOnly]="true" [showTime]="true" hourFormat="12" [style]="{'width':'100%'}"></p-calendar>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button pButton label="Cancel" (click)="showstatusnotes = false" class="p-button-text p-button-secondary ml-2"></button>
      <button pButton label="Save" (click)="saveStatusAndNotes()" class="p-button-outlined p-button-success"></button>

    </ng-template>
  </p-dialog>
